import gql from 'graphql-tag';

const GET_TASK_DATE = gql`
  query getTaskDate(
    $where: TaskWhereInput
    $orderBy: TaskOrderByInput
    $skip: Int
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    getTaskDate: tasksConnection(
      where: $where
      orderBy: $orderBy
      skip: $skip
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          dueDate
          status
          createdBy {
            id
          }
          assigneeUsers {
            id
            name
            username
            avatar {
              id
              key
            }
          }
          assigneeUser {
            id
            name
            username
            avatar {
              id
              key
            }
          }
          followers {
            id
          }
          collaborators {
            id
          }
        }
      }
      aggregate {
        count
      }
    }
    full: tasksConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default GET_TASK_DATE;
